import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { HandleError, HttpErrorHandler } from '../../../util/http-error-handler.service';
import { debug } from 'util';
import { ControDeAcesso } from '../../../models/controle-acesso/ControleDeAcesso';

const API_URL = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class ControleDeAcessoService {
  private handleError: HandleError;
  menuItems: Array<any>;

  constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler) {
    this.menuItems = [];
    this.handleError = httpErrorHandler.createHandleError('CentroDeCustoService');
  }
  obterUsuario(descricao: string): Observable<any> {
    const params = new HttpParams()
      .set('email', `${descricao}`);
    return this.http.get<any>(API_URL + 'v1/accesscontrol/searchuser/', { params })
      .pipe(
        catchError(this.handleError('obterTodos', []))
      );
  }

  obterGrupos(): Observable<any> {
    return this.http.get<any>(`${API_URL}v1/accesscontrol/listgroup`)
      .pipe(
        catchError(this.handleError('obterGrupos', []))
      );
  }

  obterPaginas(deviceId: any): Observable<any> {
    return this.http.get<any>(`${API_URL}v1/accesscontrol/listpages?deviceId=${deviceId}`)
      .pipe(
        catchError(this.handleError('obterPaginas', []))
      );
  }
  obterDevices(): Observable<any> {
    return this.http.get<any>(API_URL + 'v1/accesscontrol/listdevices')
      .pipe(
        catchError(this.handleError('listdevices', []))
      );
  }


  cadastrarPermissao(produto: ControDeAcesso): Observable<any> {
    return this.http.post<ControDeAcesso>(API_URL + 'v1/accesscontrol', produto)
      .pipe(
        catchError(this.handleError('cadastrarProduto', produto))
      );
  }

  obterTodos(param: any, direcao: string, propriedade: string): Observable<any> {
    const params = new HttpParams()
      .set('Direcao', `${(direcao)}`)
      .set('Propriedade', `${(propriedade)}`)
      .set('page', `${param.offset}`)
      .set('pageSize', `${param.limit}`)
      .set('descricao', `${param.descricao}`)
      .set('state', `${(param.state == true ? 1 : 0)}`);
    return this.http.get<any>(API_URL + "v1/accesscontrol/", { params })
      .pipe(
        catchError(this.handleError('obterTodos', []))
      );
  }


  obterPorCodigo(id: number): Observable<any> {
    return this.http.get<any>(API_URL + "v1/accesscontrol/" + id)
      .pipe(
        catchError(this.handleError('obterPorCodigo', []))
      );
  }

  atualizarPermissao(produto: ControDeAcesso): Observable<any> {
    return this.http.put<ControDeAcesso>(API_URL + '/v1/accesscontrol', produto)
      .pipe(
        catchError(this.handleError('cadastrarProduto', produto))
      );
  }

  removerAcesso(id: number): Observable<any> {
    return this.http.delete<any>(API_URL + "v1/accesscontrol/" + id)
      .pipe(
        catchError(this.handleError('removerAcesso', []))
      );
  }

  obterPermissoes(id: number): Observable<any> {
    return this.http.get<any>(API_URL + "v1/accesscontrol/listPermissions/" + id)
      .pipe(
        catchError(this.handleError('obterPorCodigo', []))
      );
  }
}
